import { render } from "./initiative-details.view.vue?vue&type=template&id=4a1bd22d&scoped=true&ts=true"
import script from "./initiative-details.view.vue?vue&type=script&lang=ts"
export * from "./initiative-details.view.vue?vue&type=script&lang=ts"

import "./initiative-details.view.vue?vue&type=style&index=0&id=4a1bd22d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1bd22d"]])

export default __exports__